/**
 * The landing page's campaign figures. env.js publishes launch placeholders on
 * window.CAMPAIGN (the same footing as the landing's simulated live counters);
 * the admin backend will overwrite that object with real values later, with no
 * app change needed.
 */
export interface KhatamCampaign {
  khatamsDone: number;
  khatamTarget: number;
  /** ISO timestamp the campaign ends at, or null for no deadline. */
  deadline: string | null;
}

declare global {
  interface Window {
    CAMPAIGN?: Partial<KhatamCampaign>;
  }
}

export const PAGES_PER_KHATAM = 604;

export function loadCampaign(): KhatamCampaign {
  const raw = window.CAMPAIGN || {};
  const target = Math.max(1, Math.floor(raw.khatamTarget ?? 100));
  return {
    khatamsDone: Math.max(0, Math.min(target, Math.floor(raw.khatamsDone ?? 0))),
    khatamTarget: target,
    deadline: raw.deadline ?? null,
  };
}

/** "4d 12h" / "3h 20m" / "0m" — the compact remaining-time the timer chip shows. */
export function remainingTimeText(deadline: string, now: Date = new Date()): string | null {
  const end = new Date(deadline).getTime();
  if (!Number.isFinite(end)) return null;
  let mins = Math.floor((end - now.getTime()) / 60000);
  if (mins <= 0) return '0m';
  const days = Math.floor(mins / 1440);
  mins -= days * 1440;
  const hours = Math.floor(mins / 60);
  mins -= hours * 60;
  if (days > 0) return days + 'd ' + hours + 'h';
  if (hours > 0) return hours + 'h ' + mins + 'm';
  return mins + 'm';
}
